module.exports = __webpack_public_path__ + "static/media/ESA-Series.9dbff683.png";